import { render, staticRenderFns } from "./ParentCarerView.vue?vue&type=template&id=10e37cae&scoped=true&"
import script from "./ParentCarerView.vue?vue&type=script&lang=js&"
export * from "./ParentCarerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e37cae",
  null
  
)

export default component.exports